import {ref} from '@vue/composition-api'

export function useCategoryList() {
  let categoryList = ref([]);
  const { ServiceFactory } = require('@/service/ServiceFactory');
  const instance = ServiceFactory.get('category');

  async function fetchCategories(token: string) {
    try {
      const { data } = await instance.list(token);
      categoryList.value = data;
    } catch (e) {
      const message: string = e.response ? e.response.data.message || e.response.data.error : e.message;
      throw Error(message);
    }
  }

  return {
    categoryList,
    fetchCategories
  };
}
